import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Typography } from "components";
import UserInfo from "./UserInfo";
import NOKInfo from "./NOKInfo";
import GuarantorInfo from "./GuarantorInfo";
import Documents from "./Documents";
import { BiDownload } from "react-icons/bi";
import { clearAgentDetails } from "redux/actions/onboardingActions";
import { permissions } from "utils/permissions";
import { useSelector } from "react-redux";
import { hasPermission } from "utils/helper";

const OnboardingDetails = (props) => {
  const location = useLocation();

  const agentId = location?.state?.agentId || props.agentId;

  const [currentId, setCurrentId] = useState(1);

  const user = useSelector((state) => state.user);
  const userAuthorities = user?.user?.authorities;

  useEffect(() => {
    return () => clearAgentDetails();
  }, []);

  const sections = [
    {
      id: 1,
      header: "User's Information",
      component: <UserInfo agentId={agentId} />,
    },
    {
      id: 2,
      header: "Next of Kin's Details",
      component: <NOKInfo agentId={agentId} />,
    },
    {
      id: 3,
      header: "Guarantor Details",
      component: <GuarantorInfo agentId={agentId} />,
    },
    {
      id: 4,
      header: "Documents Attached",
      component: (
        <Documents
          agentId={agentId}
          allowDocumentValidation={props.allowDocumentValidation}
        />
      ),
    },
  ];

  return (
    <>
      <div
        className="d-sm-flex justify-content-between"
        style={{ position: "relative" }}
      >
        {sections.map(({ id, header }, key) => (
          <div
            className={currentId === id ? "header-active" : "header-inactive"}
            id={id}
            key={key}
            onClick={() => setCurrentId(id)}
          >
            <Typography
              state={currentId === id ? "primary" : "grey"}
              variant="body0"
              className={"cursor-pointer"}
            >
              {header}
            </Typography>
          </div>
        ))}
      </div>
      <div style={{ marginTop: "3rem" }}>
        {sections.find((section) => section.id === currentId)?.component}
      </div>
      {hasPermission(permissions.canDownloadKYC, userAuthorities) && (
        <a
          href={`${process.env.REACT_APP_API_URL}/tms/portal/agent/${agentId}/download`}
          style={{ textDecoration: "none" }}
        >
          <div className="kyc-export-cta">
            <div>
              <BiDownload /> Export KYC Info
            </div>
          </div>
        </a>
      )}
    </>
  );
};

export default OnboardingDetails;
